// extracted by mini-css-extract-plugin
export var drawerPaper = "_19-0";
export var itemCard = "_19-1";
export var itemImage = "_19-2";